import React from "react"
import useSWR from "swr"
import { fetchSavedIncentiveList, SavedIncentiveListDetail } from "../api/incentiveListApi"
import { BaseModal } from "./BaseModal"
import { Box, Center, Loader, ScrollArea, Table, Text } from "@mantine/core"

interface Props {
  opened: boolean
  clientId: number
  savedId: number | null
  name: string
  onClose: () => void
  onExited: () => void
}

// 保存済み対象者リストの詳細（対象者一覧）モーダル
const IncentiveListSavedDetailModal: React.FC<Props> = ({
  opened,
  clientId,
  savedId,
  name,
  onClose,
  onExited,
}) => {
  // 閉じ切ったタイミングで親が savedId を null にするため、閉じている間は取得しない。
  // opened ではなく savedId を条件にすることで、閉じるアニメーション中に
  // 内容がローディング表示へ切り替わってちらつくのを防ぐ
  const { data, error } = useSWR<SavedIncentiveListDetail>(
    savedId !== null ? `incentive-lists-saved-${clientId}-${savedId}` : null,
    () => fetchSavedIncentiveList(clientId, savedId as number),
  )

  return (
    <BaseModal
      opened={opened}
      onClose={onClose}
      title="特典付与対象者リスト"
      onExited={onExited}
    >
      <Box px={24} py={16}>
        <Text fw={600}>{name}</Text>
      </Box>

      <ScrollArea style={{ flex: 1, minHeight: 0 }} px={24} pb={24}>
        {error && <Text fz={13} c="red">読み込みに失敗しました</Text>}
        {!error && !data && (
          <Center mih={200}>
            <Loader />
          </Center>
        )}
        {data && (
          <Box
            style={{
              border: '1px solid #0000001A',
              borderRadius: 8,
              overflow: 'hidden',
            }}
          >
            <Table withColumnBorders styles={{ th: { backgroundColor: '#00000008' } }}>
              <Table.Thead>
                <Table.Tr>
                  <Table.Th>氏名</Table.Th>
                  <Table.Th>メールアドレス</Table.Th>
                  <Table.Th>紹介/友人</Table.Th>
                  <Table.Th ta="right">紹介/申込件数</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {data.entries.length === 0 && (
                  <Table.Tr>
                    <Table.Td colSpan={4}>
                      <Text c="#00000099" ta="center" py="md">対象者がいません</Text>
                    </Table.Td>
                  </Table.Tr>
                )}
                {data.entries.map((e, i) => (
                  <Table.Tr key={`${e.email}-${e.role}-${i}`}>
                    <Table.Td>{e.name}</Table.Td>
                    <Table.Td>{e.email}</Table.Td>
                    <Table.Td>{e.role}</Table.Td>
                    <Table.Td ta="right">{e.count}</Table.Td>
                  </Table.Tr>
                ))}
              </Table.Tbody>
            </Table>
          </Box>
        )}
      </ScrollArea>
    </BaseModal>
  )
}

export default IncentiveListSavedDetailModal
